<div class="side-nav">
  <mat-list class="side-nav-list">
    <mat-list-item *ngFor="let dataConfig of dataConfigs">
      <button
        mat-button
        (click)="selectSidebarElement(dataConfig)"
        [title]="getTitleForDataConfig(dataConfig)"
      >
        <div
          class="data-config-name"
          *ngIf="dataConfig['displayName']"
          [ngClass]="{ 'selected-data-config': isSelected(dataConfig) }"
        >
          <div class="name-div">{{ dataConfig["displayName"] }}</div>
          <div class="hidden-text" *ngIf="dataConfig['visible'] === false">
            (hidden)
          </div>
        </div>
        <div
          class="data-config-name"
          *ngIf="dataConfig['aggregategroup_displayname']"
          [ngClass]="{ 'selected-data-config': isSelected(dataConfig) }"
        >
          <div class="name-div">
            {{ dataConfig["aggregategroup_displayname"] }}
          </div>
          <div class="hidden-text" *ngIf="dataConfig['visible'] === false">
            (hidden)
          </div>
        </div>
      </button>
    </mat-list-item>
  </mat-list>
</div>
